<template>
    <el-dialog title="邀请好友" top="10vh" :visible.sync="visible" width="1000px" @close="handleClose" append-to-body>
        <div slot="title">
            <el-tabs v-model="activeName" @tab-click="handleClickTab">
                <el-tab-pane v-for="(item, index) in tabList" :label="item.label" :name="item.name" :key="index"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="content" v-if="activeName === 'first'">
            <div class="table-container">
                <el-table :data="tableData" style="width: 100%;" height="400">
                    <el-table-column label="日期" prop="addDate"></el-table-column>
                    <el-table-column label="被邀请人" prop="clientName"></el-table-column>
                    <el-table-column label="状态" prop="certStatus">
                        <template slot-scope="scope">
                            <span :style="{ color: certStatusColorMap[scope.row.certStatus] }">{{ certStatusMap[scope.row.certStatus] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" prop="operation">
                        <template slot-scope="scope">
                            <el-link type="primary" v-if="scope.row.certStatus == 0" @click="handleClickNotify(scope.row)" :disabled="scope.row.certStatus == 1">复制链接提醒ta认证</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="content" v-else>
            <div class="search-container">
                <div>
                    <el-radio-group v-model="form.type" @change="handleChangeOrderOrNumbers">
                        <el-radio-button label="1">邀请订单</el-radio-button>
                        <el-radio-button label="2">邀请人数</el-radio-button>
                    </el-radio-group>
                </div>
                <!-- // 添加回车监听 -->
                <el-input 
                    v-model="form.search" 
                    :placeholder="form.type == 1? '请输入订单编号':'请输入被邀请人姓名'" 
                    style="width: 220px; margin: 0px 12px"
                    @keyup.enter.native="handleSearch"  
                ></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜 索</el-button>
            </div>
            <div class="table-container">
                <el-table :data="tableData" style="width: 100%;" height="400">
                    <el-table-column label="日期" prop="addDate"></el-table-column>
                    <el-table-column label="被邀请人" prop="clientName"></el-table-column>
                    <el-table-column label="类型" prop="type">
                        <template>
                            <span>{{ form.type == 1 ? '邀请订单' : '邀请注册' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="form.type == 1" label="订单编号" prop="orderCode"></el-table-column>
                    <el-table-column label="奖励金额（元）" prop="amount">
                        <template slot-scope="scope">
                            <span>{{ getAmount(scope.row.amount) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" prop="status">
                        <template slot-scope="scope">
                            <span :style="{ color: statusColorMap[scope.row.status] }">{{ statusMap[scope.row.status] }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="pagination">
            <el-pagination layout=" total, sizes,prev, pager, next, jumper" :total="form.total" :page-size="pageForm.pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
        </div>
    </el-dialog>
</template>
<script>
import { getInviteFriendsList, getEstimateIncomeList } from '@/api/request';
export default {
    name: 'inviteFriendsDlg',
    data() {
        return {
            visible: false,
            activeName: 'first',
            tabList: [
                {
                    label: '邀请人数',
                    name: 'first',
                    index: 1
                },
                {
                    label: '预估收益',
                    name: 'second',
                    index: 2
                },
                {
                    label: '已结算',
                    name: 'third',
                    index: 3
                }
            ],
            tableData: [],
            pageForm:{
                pageSize: 10,
                pageNum: 1,
            },
            form: {
                total: 0,
                type: 1,
                search: ''
            },
            statusMap: {
                1: "待结算",
                2: "已结算",
                3: "已失效",
            },
            statusColorMap: {
                1: "#FE5900",
                2: "#448807",
                3: "#7E8488",
            },
            certStatusMap: {
                0: '未认证',
                1: '已认证',
                2: '审核中'
            },
            certStatusColorMap: {
                1: '#FF9D00',
                2: '#7E8488',
                3: '#ff4a2b'
            },

        };
    },

    methods: {
        getAmount(amount) {
            if (amount) {
                return Number(amount).toFixed(2);
            } else {
                return "0.00";
            }
        },
        publicOpen(index) {
            const item = this.tabList.find(item => item.index === index);
            this.activeName = item.name;
            this.visible = true;
            this.pageForm.pageNum = 1;
            this.getData();
        },
        handleClose() {
            this.form.search = '';
        },
        handleClickTab(tab, event) {
            this.activeName = tab.name;
            this.pageForm.pageNum = 1;
            this.getData();
        },
        handleClickNotify(row) {
            const url = `${process.env.VUE_APP_POET}/aboutUsIndex?type=13&tabIndex=1-6&tabName=身份认证`
            const input = document.createElement('input');
            input.value = url;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success('复制成功');
        },
        handleSearch(){
            this.pageForm.pageNum = 1;
            this.getData();
        },
        handleChangeOrderOrNumbers() {
            this.pageForm.pageNum = 1;
            this.form.search = '';
            this.getData();
        },
        handleCurrentChange(currentPage) {
            this.pageForm.pageNum = currentPage;
            this.getData();
        },
        handleSizeChange(pageSize) {
            this.pageForm.pageSize = pageSize;
            this.getData();  
        },
        getData() {
            this.tableData = [];
            if (this.activeName === 'first') {
                const params = {
                    ...this.pageForm,
                    queryType:1
                };
                getInviteFriendsList(params).then((res) => {
                    console.log(res);
                    const { rows, total } = res;
                    this.form.total = total;
                    this.tableData = rows;
                });
            } else {
                let params = {
                    ...this.pageForm,
                };
                if(this.activeName === 'third'){
                    if(this.form.type == 1){
                        params.status = 2;
                    }else if(this.form.type == 2){
                        params.newStatus = 2;
                    }
                }
                if (this.form.type == 1) {
                    params.orderCode = this.form.search;
                    getEstimateIncomeList(params).then((res) => {
                        console.log('getEstimateIncomeList',res);
                        if (res.code == 200) {
                            const { rows, total } = res;
                            this.form.total = total;
                            this.tableData = rows;
                        }
                    });
                } else {
                    params.clientName = this.form.search;
                    getInviteFriendsList(params).then((res) => {
                        if (res.code == 200) {
                            const { rows, total } = res;
                            this.form.total = total;
                            this.tableData = rows;
                        }
                    });
                }
            }
        }
    }
};
</script>
<style scoped lang="scss">
.content {
    margin-top: -30px;
    .search-container {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    .table-container {
    }
}
.pagination {
    margin-top: 20px;
    text-align: center;
}
</style>
